var plugin = require('jaxcore-plugin'); // var log = plugin.createLogger('Spin Buffer');


var _instance = 0;

function SpinBuffer(spin, config) {
  this.log = plugin.createLogger('Spin Buffer ' + _instance++);
  this.log('created buffer', spin.id);
  this.delayTime = 0;
  this.spinDelayed = false;
  this.staticBuffer = 0;
  this.kineticBuffer = 0;
  this.spinDirection = 0;
  this.lastSpinTime = 0;
  if (!config) config = {};
  this.defaultDelay = config.defaultDelay || 500;
  this.staticTimeout = config.staticTimeout || 2000;
  this.delayLength = this.defaultDelay;
  this._onPushKnob = this.onPushKnob.bind(this);
  spin.on('knob', this._onPushKnob);
  var me = this;

  this.destroy = function () {
    spin.removeListener('knob', me._onPushKnob);
  };
}

SpinBuffer.prototype = {};

SpinBuffer.prototype.reset = function (forceStatic) {
  this.staticBuffer = 0;
  this.kineticBuffer = 0;

  if (forceStatic) {
    this.spinDirection = 0;
  }
};

SpinBuffer.prototype.onPushKnob = function () {
  this.log('reset');
  this.reset();
};

SpinBuffer.prototype.spin = function (direction, kineticBuffer, staticBuffer, momentumTimeout) {
  if (!kineticBuffer) kineticBuffer = 0;

  if (typeof staticBuffer === 'undefined') {
    if (kineticBuffer) staticBuffer = kineticBuffer;else staticBuffer = 0;
  }

  kineticBuffer += 1;
  staticBuffer += 1;
  var timeSinceLastSpin = new Date().getTime() - this.lastSpinTime;

  if (momentumTimeout && timeSinceLastSpin > momentumTimeout) {
    if (this.kineticBuffer >= kineticBuffer - 1) {
      this.log('momentumTimeout subtract one from this.kineticBuffer', this.kineticBuffer, kineticBuffer);
      this.kineticBuffer = kineticBuffer - (staticBuffer || 1);
    } else {
      this.log('momentumTimeout not reached limit', this.kineticBuffer, kineticBuffer);
    }
  }

  this.lastSpinTime = new Date().getTime();

  if (this.isDelayed()) {
    this.reset();
    return false;
  }

  var staticTimeoutExceeded = timeSinceLastSpin > this.staticTimeout; // after 2 sec reset static buffer

  if (staticTimeoutExceeded) {
    this.log('static timeout exceeded');
    this.reset(true);
  }

  var directionChanged = direction !== this.spinDirection;

  if (directionChanged) {
    this.kineticBuffer = 0;
    this.staticBuffer++;

    if (this.staticBuffer >= staticBuffer) {
      this.log('static buffer exeeded, spinDirection is now', direction);
      this.spinDirection = direction;
      this.reset();
      return true;
    } else {
      this.log('static buffer:', this.staticBuffer, '-');
      return false;
    }
  } else {
    if (this.staticBuffer > 0) {
      this.staticBuffer--;
      this.log('static buffer:', this.staticBuffer, '+');
      if (this.staticBuffer < 0) this.staticBuffer = 0;
      return false;
    }

    this.kineticBuffer++;
    this.staticBuffer = 0;
    if (kineticBuffer > 0) this.log('kinetic buffer:', this.kineticBuffer, direction === 1 ? '+' : '-');

    if (this.kineticBuffer >= kineticBuffer) {
      if (kineticBuffer > 0) this.log('kinetic buffer exceeded');
      this.reset();
      return true;
    } else {
      return false;
    }
  }

  return false;
};

SpinBuffer.prototype.isDelayed = function () {
  if (this.spinDelayed) {
    var diff = new Date().getTime() - this.delayTime;
    var d = diff > this.delayLength;

    if (d) {
      this.log('delay timed out', new Date().getTime() - this.delayTime);
      this.delayLength = this.defaultDelay;
      this.spinDelayed = false;
      return false;
    } else {
      this.log('delaying for ' + (this.delayLength + ' ' + diff));
      return true;
    }
  } else {
    return false;
  }
};

SpinBuffer.prototype.delay = function (ms) {
  this.delayLength = ms || this.defaultDelay;
  this.log('delaying for ' + this.delayLength + 'ms');
  this.delayTime = new Date().getTime();
  this.spinDelayed = true;
};

SpinBuffer.prototype.cancelDelay = function () {
  this.delayTime = 0;
  this.spinDelayed = false;
};

module.exports = SpinBuffer;